<template>
  <v-card flat v-if="book">
    <div class="v-item-group v-expansion-panels">
      <div
        class="v-expansion-panel"
        v-for="(providerCourses, providerName) in getTrainingProviderCourses()"
        :key="providerName"
      >
        <div class="v-expansion-panel-header border-bottom">
          <span class="header subtitle-1">UTBILDNINGSGIVARE: {{ providerName }}</span>
          <div class="v-expansion-panel-header__icon"></div>
        </div>
        <div class="v-expansion-panel-content">
          <div class="v-expansion-panel-content__wrap">
            <div v-for="course in providerCourses" class="course-desctiption" :key="course.name">
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header">Kursnamn: </span
                >{{ course.distanceEducationProviderCourse.name }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header">Status: </span>{{ getStatus(course.status) }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header">Godkänd: </span>{{ course.approved ? 'Ja' : 'Nej' }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header">Godkännandedatum: </span>{{ course.approvedAt | date }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header">Lärare: </span>{{ course.teacherName }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header">Utbildningsmaterial skickat: </span
                >{{ course.educationalMaterialSentOn | date }}
              </div>
              <div class="course-desctiption__element" v-if="course.courseOpportunity">
                <span class="course-desctiption__element-header">Kurstillfälle: </span
                >{{ course.courseOpportunity }}
              </div>
              <div
                class="course-desctiption__element"
                v-if="dismantlingWorkerDeepeningCourseIds.includes(get(course, 'distanceEducationProviderCourseId', null))"
              >
                <span class="course-desctiption__element-header">Klarmarkerad: </span
                >
                <template v-if="!existingSpecialCourses(course)">
                  Nej
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        text
                        :style="{
                          padding: '0 !important',
                          height: '30px',
                          width: '30px'
                        }"
                        @click="handleMarkCourse(course)"
                      >
                        <v-icon small>$sl-check</v-icon>
                      </v-btn>
                    </template>
  
                    Klarmarkera kurs
                  </v-tooltip>
                </template>

                <template v-else-if="specialCoursePendingApproval(get(course, 'distanceEducationProviderCourseId', null))">
                  Väntar på klarmarkering
                </template>
                
                <template v-else-if="specialCourseApproved(get(course, 'distanceEducationProviderCourseId', null))">
                  Ja
                </template>

                <v-dialog v-model="specialCourseApprovalDialogOpen" max-width="400px">
                  <v-card>
                    <v-icon class="close mt-n2" @click="specialCourseApprovalDialogOpen = false">$sl-close</v-icon>
                    <h5 class="mt-2 mb-10">Ange godkännandedatum</h5>
                    <DatePicker
                      v-model="specialCourseApprovalDate"
                      ref="datePicker"
                      :icon="'$sl-calendar-date'"
                      outlined
                      :required="true"
                    />
                    <div class="d-flex justify-end mt-4">
                      <v-btn
                        class="icon"
                        outlined
                        @click="specialCourseApprovalDialogOpen = false"
                      >
                        <v-icon>$sl-cancel</v-icon>
                        Stäng
                      </v-btn>
                      <v-btn
                        class="icon ml-3"
                        @click="startSpecialCourseApproval()"
                      >
                        <v-icon>$sl-check</v-icon>
                        Spara
                      </v-btn>
                    </div>
                  </v-card>
                </v-dialog>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <h6 class="mb-4 mt-7" v-if="hasDistanceEducations">TEORETISKA MOMENT</h6>
    <v-expansion-panels class="progressbar">
      <template>
        <v-expansion-panel
          v-for="(course, i) in book.education.educationDistanceEducationProviderCourses"
          class="mb-4"
          :key="i"
          hide-actions
        >
          <v-row align="center" no-gutters class="mt-4 mr-4" v-if="hasDistanceEducations && isAdmin">
            <v-spacer></v-spacer>
            <v-btn outlined @click="deleteDistanceCourse(course.id)" :disabled="isElementsApproved(course, course.assignments)">
              <v-icon>$sl-delete</v-icon>Radera
            </v-btn>
            <v-btn class="ml-4" @click="approveDistanceCourse(course.id, course, course.assignments)" :disabled="isElementsApproved(course, course.assignments)">
              <v-icon>$sl-like</v-icon>
              <span class="d-xs-none">{{ $vuetify.breakpoint.xs ? 'Godk.' : 'Godkänn' }}</span>
            </v-btn>
          </v-row>
          <v-expansion-panel-header
            expand-icon="$sl-arrow-down"
            v-bind:class="{active: transformAssignments(course).approved}"
            class="border-bottom"
          >
            <v-row align="center" class="spacer" no-gutters>
              <v-col class="subtitle-1 text-uppercase bold d-flex align-center" cols="12">                
                  {{ transformAssignments(course).name }}
                  <v-icon class="ml-1" v-if="transformAssignments(course).approved">$sl-ebook-completed</v-icon>                
              </v-col>
              <v-col cols="12">
                <progressLinear
                  class="mt-n1 mb-n1"
                  :value="
                    getPercentage(
                      filter(transformAssignments(course).assignments, ['approved', true]).length,
                      transformAssignments(course).assignments.length
                    )
                  "
                ></progressLinear>
              </v-col>
            </v-row>
          </v-expansion-panel-header>

          <v-expansion-panel-content v-if="transformAssignments(course).assignments.length > 0">
            <v-container class="pt-0">
              <v-row class="no-gutters justify-end">
                <v-col cols="12"></v-col>
                <v-col cols="1" class="smallTitle align-end">
                  <div>Klar</div>
                </v-col>
                <v-col cols="2" class="smallTitle align-end" v-if="isAdmin">
                  <div>Ta bort / Godkänn</div>
                </v-col>
              </v-row>

              <div v-for="assignment in transformAssignments(course).assignments" :key="assignment.id">
                <template>
                  <v-row class="align-center" v-bind:class="[assignment.approved ? active : '', elementRow, noGutters]">
                    <v-col>
                      <div class="itemName">{{ assignment.name }}</div>
                    </v-col>
                    <v-col cols="1" class="smallTitle align-center justify-center">
                      <v-icon v-if="assignment.approved">$sl-ebook-completed</v-icon>
                    </v-col>
                    <v-col cols="2" class="text-center" v-if="isAdmin">
                      <v-icon class="mr-4" @click.stop="deleteAssignment(course.id, assignment.id)" :disabled="assignment.approved">$sl-delete</v-icon>
                      <v-icon @click.stop="approveAssignment(course.id, assignment.id)" :disabled="assignment.approved">$sl-like</v-icon>
                    </v-col>
                  </v-row>
                </template>
              </div>
            </v-container>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-else>
            <MessageBox class="my-3">
              <div >Vald teorikurs kan inte rapportera resultatet på enskilda delmoment. Teoretiska moment rapporteras därför endast som icke-färdig eller färdig.</div>
            </MessageBox>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
    </v-expansion-panels>
  </v-card>
</template>


<script>
import MessageBox from "@/components/common/MessageBox.vue";
import {mapGetters} from 'vuex'
import progressLinear from '@/components/common/ProgressLinear'
import {Utilities} from '@/components/mixins'
import filter from 'lodash/filter'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import get from 'lodash/get'
import API from '@/services/api'
import DatePicker from '@/components/common/DatePicker'

// @group Person
// DistanceEducationProviderCourses component
export default {
  name: 'DistanceEducationProviderCourses',
  mixins: [Utilities],
  props: {
    //has book
    book: Object
  },
  data() {
    return {
      active: 'active',
      elementRow: 'element-row',
      noGutters: 'no-gutters',
      detailsModal: false,
      specialCourse: null,
      specialCourseApprovalDialogOpen: false,
      specialCourseApprovalDate: new Date().toISOString()
    }
  },
  components: {
    progressLinear,
    MessageBox,
    DatePicker
  },
  computed: {
    ...mapGetters('currentuser', ['currentUserRole']),
    isAdmin() {
      return this.currentUserRole === 'admin';
    },
    hasDistanceEducations() {
      return get(this, 'book.education.educationDistanceEducationProviderCourses', []).length > 0
    },
    dismantlingWorkerDeepeningCourseIds() {
      return [77,78,80]
    }
  },
  methods: {
    get,
    filter: filter,
    
    async approveDistanceCourse(elementId, course, assignments = []) {
      let feedback = 'Delmoment godkänd.'
      const response = await this.$dialog.confirm({
        title: 'Godkänn moment?',
        text: 'Samtliga tillhörande delmoment kommer också att bli godkända.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Godkänn', key: true, icon: '$sl-like', outlined: true}
        ]
      })

      if(response !== true) return

      // handle special course
      const specialCourse = this.dismantlingWorkerDeepeningCourseIds.includes(get(course, 'distanceEducationProviderCourseId', null))
      if ( specialCourse ) {
        feedback = null
        const specialCoursePendingApproval = this.specialCoursePendingApproval(get(course, 'distanceEducationProviderCourseId', null))
        if ( specialCoursePendingApproval )
          await this.approveSpecialCourse(course)
        else {
          this.specialCourse = course
          this.specialCourseApprovalDialogOpen = true
        }

        return
      }

      course.approved = true
      course.approvedAt = new Date()

      API.updateDistanceCourse(elementId, { data: { approved: true, approvedAt: new Date() } }).then((response) => {
        for (const assignment of assignments) {
          assignment.approved = true
        }
        
        if ( feedback )
          this.$events.fire('showInfo', feedback)
      })
    },

    async approveAssignment(elementId, id) {
      const response = await this.$dialog.confirm({
        title: 'Godkänn delmoment?',
        text: 'Vill du godkänna delmomentet?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Godkänn', key: true, icon: '$sl-like', outlined: true}
        ]
      })

      if(response !== true) return

      const assignments = this.findAssignmentAndApprove(id)

      API.updateAssignments(this.book?.id, elementId, { data: { assignments } }).then((response) => {
        this.$events.fire('showInfo', 'Delmoment godkänd.')
        
        if(Boolean(assignments?.some(a => !a.approved))) return 
        
        API.updateDistanceCourse(elementId, { data: { approved: true, approvedAt: new Date() }}).then((response) => {
          const course = this.book?.education?.educationDistanceEducationProviderCourses.find(o => o.id === elementId)
          course.approved = true
          course.approvedAt = new Date()
        })
      })
    },

    async deleteDistanceCourse(elementId) {
      const response = await this.$dialog.confirm({
        title: 'Radera moment?',
        text: 'Samtliga tillhörande delmoment kommer också att raderas. Radering av moment går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if(response !== true) return

      API.deleteDistanceCourse(elementId).then((response) => {
        this.filterDeletedCourses(elementId)
        this.$events.fire('showInfo', 'Moment raderad.')
      })
    },

    async deleteAssignment(elementId, id) {
      const response = await this.$dialog.confirm({
        title: 'Radera delmoment?',
        text: 'Vill du radera delmoment? Radering av delmoment går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if(response !== true) return

      const assignments = this.filterDeletedAssignments(id)

      API.updateAssignments(this.book?.id, elementId, { data: { assignments } }).then((response) => {
        this.$events.fire('showInfo', 'Delmoment raderad.')

        if(Boolean(assignments?.some(a => !a.approved))) return

        API.updateDistanceCourse(elementId, { data: { approved: true, approvedAt: new Date() }}).then((response) => {
          const course = this.book?.education?.educationDistanceEducationProviderCourses.find(o => o.id === elementId)
          course.approved = true
          course.approvedAt = new Date()
        })
      })
    },

    filterDeletedCourses(elementId) {
      const elIdx = findIndex(this.book.education.educationDistanceEducationProviderCourses, e => {
        return e.id == elementId
      })

      if (elIdx === -1) return
      this.book.education.educationDistanceEducationProviderCourses.splice(elIdx, 1)
    },

    filterDeletedAssignments(id) {
      const elIdx = findIndex(this.book.education.educationDistanceEducationProviderCourses, e => {
        return e.assignments.find(a => a.id === id)
      })

      const itIdx = findIndex(this.book.education.educationDistanceEducationProviderCourses[elIdx].assignments, assignment => {
        return assignment.id === id
      })

      if (elIdx > -1) {
        this.book.education.educationDistanceEducationProviderCourses[elIdx].assignments.splice(itIdx, 1)
        return filter(this.book.education.educationDistanceEducationProviderCourses[elIdx].assignments, o => {
          return o.id !== id
        })
      }
    },

    findAssignmentAndApprove(id) {
      const elIdx = findIndex(this.book.education.educationDistanceEducationProviderCourses, e => {
        return e.assignments.find(a => a.id === id)
      })

      const assignment = find(this.book.education.educationDistanceEducationProviderCourses[elIdx].assignments, assignment => {
        return assignment.id === id
      })

      assignment.approved = true

      return this.book.education.educationDistanceEducationProviderCourses[elIdx].assignments
    },

    transformAssignments(course) {
      let arr = {
        approved: course.approved,
        assignments: course.assignments ? course.assignments : [],
        name: course.distanceEducationProviderCourse.name
      }
      
      return arr
    },
    getTrainingProviderCourses() {
      const educationProviderCourses = get(this.book, 'education.educationDistanceEducationProviderCourses', [])
      const mapedByProvider = educationProviderCourses.reduce((acc, el) => {
        const providerName = get(el, 'distanceEducationProviderCourse.distanceEducationProvider.name', 'unknown')
        if (acc[providerName]) {
          acc[providerName].push(el)
        } else {
          acc[providerName] = [el]
        }
        return acc
      }, {})
      return mapedByProvider
    },
    getStatus(status) {
      switch (status) {
        case 'active':
          return 'Aktiv'
        case 'approved':
          return 'Godkänd'
        default:
          return status
      }
    },

    isElementsApproved(course, assignments) {
      if ( !assignments.length ) return course.approved
      return course.approved || filter(assignments, ['approved', true]).length === assignments.length
    },

    async startSpecialCourseApproval() {
      try {
        if ( !get(this, 'specialCourse', null) ) return
        await API.startSpecialCourseApproval({
          data: {
            bookId: get(this, 'book.id', null),
            distanceEducationProviderCourseId: get(this, 'specialCourse.distanceEducationProviderCourseId', null),
            approvedAt: get(this, 'specialCourseApprovalDate', null)
          }
        })

        this.specialCourseApprovalDialogOpen = false
        
        let feedback = ''
        if ( this.isAdmin ) {
          const specialCourseName = get(this, 'specialCourse.distanceEducationProviderCourse.name', null)
          feedback = `Delmoment och kursen ${specialCourseName} är nu markerad som godkänd.`
        }
        else feedback = 'Klarmarkerad av första part.'

        this.$events.fire('showInfo', feedback)
        this.$emit('save')
      } catch (error) {
        this.$events.fire('showError', 'Kunde inte klarmarkera kursen. Försök igen senare.')
      }
    },

    async approveSpecialCourse(course = {}) {
      try {
        const specialCourseId = this.existingSpecialCourses(course)?.id
        if ( !specialCourseId ) throw new Error('A special course ID is missing')

        await API.updateDistanceCourse(get(course, 'id', null), { data: { approved: true, approvedAt: new Date() } })
        for (const assignment of get(course, 'assignments', [])) {
          assignment.approved = true
        }
        
        await API.completeSpecialCourseApproval(specialCourseId)
        this.$emit('save')

        const specialCourseName = get(course, 'distanceEducationProviderCourse.name', null)

        this.$events.fire('showInfo', `Delmoment och kursen ${specialCourseName} är nu markerad som godkänd.`)
      } catch (error) {
        this.$events.fire('showError', get(error, 'message', 'Kunde inte godkänna kursen. Försök igen senare.'))
      }
    },

    specialCoursePendingApproval(courseId) {
      if ( !courseId ) return false
      const course = get(this, 'book.specialCourseApprovals', []).find(sC => get(sC, 'distanceEducationProviderCourseId', null) === courseId)
      return get(course, 'status', null) === 'pending_second_approval'
    },

    specialCourseApproved(courseId) {
      if ( !courseId ) return false
      const course = get(this, 'book.specialCourseApprovals', []).find(sC => get(sC, 'distanceEducationProviderCourseId', null) === courseId)
      return get(course, 'status', null) === 'approved'
    },

    handleMarkCourse(course = {}) {
      this.specialCourse = course
      this.specialCourseApprovalDialogOpen = true
    },

    existingSpecialCourses(course = {}) {
      if ( !course ) return false
      const specialCourses = get(this, 'book.specialCourseApprovals', [])
      return specialCourses.find(sC => get(sC, 'distanceEducationProviderCourseId', null) === get(course, 'distanceEducationProviderCourseId', null))
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
